import React, { useEffect } from "react";
import HoverIconButton from "components/HoverIconButton";
import { MENU_ROOT } from "utils/constants/checkout";
import { scrollTopForId } from "utils/scroll";
import { useScroll } from "utils/hooks/ui";
import { useFormikContext } from "formik";
import get from "lodash/get";
import { OVERSCROLL_CONTENT } from "utils/constants/ui";

const DEFAULT_CLASSES = {
  container: "w-100 h-100 overflow-y-scroll bg-white bh--inset relative",
  scrollTop: "flex w-100 justify-end pa3 dib pointer sticky top-0 z-1"
};
const OverscrollContent = ({ children, intent, customClasses }) => {
  const classes = { ...DEFAULT_CLASSES, ...customClasses };
  const contentId = `${OVERSCROLL_CONTENT}--${intent || MENU_ROOT}`;
  const { values } = useFormikContext();

  const activeBlock = get(values, "editor.activeBlock");
  const activeSection = get(values, "editor.activeSection");
  const editorIntent = get(values, "editor.intent");
  const menuIntent = get(values, "editor.menu.intent");
  const menuActiveIndex = get(values, "editor.menu.activeIndex");
  const menuActiveSubIndex = get(values, "editor.menu.activeSubIndex");
  const menuSubIntent = get(values, "editor.menu.subIntent");
  const menuThirdIntent = get(values, "editor.menu.thirdIntent");

  useEffect(() => {
    scrollTopForId(contentId, { behavior: "auto" });
  }, [
    contentId,
    activeBlock,
    activeSection,
    editorIntent,
    menuIntent,
    menuSubIntent,
    menuThirdIntent,
    menuActiveIndex,
    menuActiveSubIndex
  ]);

  const { ref: scrollRef, scrolled, setScrolled } = useScroll();

  return (
    <div
      ref={scrollRef}
      id={contentId}
      /**
       * Important to have the h-100
       */
      className={classes.container}
    >
      {children}
      {scrolled && (
        <div className={classes.scrollTop}>
          <HoverIconButton
            icon="up"
            tooltip="Scroll top"
            onClick={() => {
              scrollTopForId(contentId);
              setScrolled(false);
            }}
          />
        </div>
      )}
      <div className="w-100 bg-transparent" style={{ height: 500 }}></div>
    </div>
  );
};

export default OverscrollContent;
